/**
 * Broadcast connection status updates
 */

import { fireEvent, TAUIDomEvent } from "../common/dom/fire_event";

export type ConnectionStatus = "connected" | "auth-invalid" | "disconnected";

declare global {
  // for fire event
  interface TAUIDomEvents {
    "connection-status": ConnectionStatus;
  }

  interface GlobalEventHandlersEventMap {
    "connection-status": TAUIDomEvent<ConnectionStatus>;
  }
}

export const broadcastConnectionStatus = (status: ConnectionStatus) => {
  fireEvent(window, "connection-status", status);
};
